import { Component } from "react";
import { connect } from "react-redux";
import { GET_ALL_PAZIEN_USERS } from "common/actions/reports";

import { WebixComments } from "common/components/webix/react/Comments";
import { ErrorView } from "common/components/error";

const mapStateToProps = (state) => ({
    currentUser: state.common.user._id,
    users: state.reports.users.data,
    loading: state.reports.users.loading,
    error: state.reports.users.error
});

const mapDispatchToProps = {
    GET_ALL_PAZIEN_USERS
};

class ReportComments extends Component {
    componentDidMount() {
        if (this.props.users === null) {
            this.props.GET_ALL_PAZIEN_USERS();
        }
    }
    
    getUsers() {
        return this.props.users;
    }
    
    render() {
        if (this.props.itemId === "new") {
            return (
                <div className="comments-box">
                    <ErrorView
                        message="Comments are disabled for new items"
                        header=""
                        custom
                        captureInSentry={false}
                        actions={false}
                        hideDetails
                    />
                </div>
            );
        }
        if (this.props.loading) {
            return (
                <div className="comments-box">
                    <div className="text-input__loading--line medium" />
                    <div className="text-input__loading--line long" />
                </div>
            );
        }
        
        if (this.props.error) {
            return <ErrorView message="Unable to fetch users" header="Error" custom />;
        }
    
        return (
            <WebixComments
                className="comments-box"
                currentUser={this.props.currentUser}
                users={this.getUsers()}
                url={`/admin/reports/${this.props.reportId}/${this.props.itemId}/comments`}
            />
        );
    }
}

export const CommentsRedux = connect(mapStateToProps, mapDispatchToProps)(ReportComments);
